import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable ({
    providedIn: 'root'
})

export class DayBookListService {
    constructor(private http: HttpClient) {}

    lFN_GetDayBookList() {
        return this.http.get(`${environment.ROOT_URL}/jsyogaccounts/accounts`, { withCredentials: true, responseType: 'text', observe: 'response' });
    }

    lFN_GetDayBookListCategoryWise(txnCategoriesSelected: any) {
        return this.http.post(`${environment.ROOT_URL}/jsyogaccounts/accounts`, txnCategoriesSelected, { withCredentials: true, responseType: 'text', observe: 'response' });
    }

    lFN_GetAccountHeaderById(accountsheaderId: number) {
        return this.http.get(`${environment.ROOT_URL}/jsyogaccounts/accounts/accountsheaderId/` + accountsheaderId, { withCredentials: true, responseType: 'text', observe: 'response' });
    }

    lFN_ToggleReceiptStatus(accountsheaderId: number, bookNo: number, receiptNo: number) {
    return this.http.patch(
      `${environment.ROOT_URL}/jsyogaccounts/receiptStatus/accountsheaderId/${accountsheaderId}/bookNo/${bookNo}/receiptNo/${receiptNo}`, 
      { withCredentials: true, responseType: 'text', observe: 'response' }
    );
  }
}